import React from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { ChartTooltip, SERIES } from "./chartTheme";

const tick = { fontSize: 11, fill: "hsl(150, 10%, 46%)", fontFamily: "Segoe UI Regular, sans-serif, system-ui" };

const BenchmarkChart = ({ data = [] }) => (
  <ResponsiveContainer width="100%" height="100%">
    <BarChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: -12 }} barGap={4}>
      <CartesianGrid strokeDasharray="3 3" stroke="hsl(140, 8%, 90%)" vertical={false} />
      <XAxis dataKey="metric" tick={tick} axisLine={{ stroke: "hsl(140, 8%, 88%)" }} tickLine={false} />
      <YAxis tick={tick} axisLine={false} tickLine={false} unit="%" width={36} />
      <Tooltip content={<ChartTooltip suffix="%" />} cursor={{ fill: "hsl(140, 8%, 95%)" }} />
      <Legend wrapperStyle={{ fontSize: 11, fontFamily: "Segoe UI Regular, sans-serif, system-ui" }} />
      <Bar dataKey="you" name="You" fill={SERIES.you} radius={[4, 4, 0, 0]} maxBarSize={30} />
      <Bar dataKey="team" name="Team avg" fill={SERIES.team} radius={[4, 4, 0, 0]} maxBarSize={30} />
    </BarChart>
  </ResponsiveContainer>
);

export default BenchmarkChart;
